import { faCircle } from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import Spinner from 'components/UI/V3/Spinner';
import { FunctionComponent } from 'react';
import styles from './ProcessingMethodCard.module.scss';

interface ProcessingMethodCardProps {
    selected: boolean;
    value: string;
    description: string;
    loading?: boolean;
    disabled?: boolean;
    onSelect: () => void;
    id?: string;
}

export const ProcessingMethodCard: FunctionComponent<ProcessingMethodCardProps> = ({
    selected,
    value,
    description,
    loading = false,
    disabled = false,
    onSelect,
    id
}) => {
    return (
        <button
            type="button"
            id={id}
            className={styles.card}
            disabled={disabled}
            aria-pressed={selected}
            onClick={onSelect}
        >
            <FontAwesomeIcon
                icon={selected ? faCircleCheck : faCircle}
                className={clsx(styles.check, selected ? styles.selectedIcon : styles.unselectedIcon)}
            />
            <div className={styles.value}>{loading ? <Spinner size={24} /> : value}</div>
            <p className={styles.description}>{description}</p>
        </button>
    );
};

export default ProcessingMethodCard;
